import { useRef, useState } from "react";
import { Heart, PawPrint } from "lucide-react";
import { CatFace, MOODS } from "@/components/yarn/Cat";

const EFFECTS = {
  love: <span className="flex gap-0.5"><Heart size={14} fill="#EC4899" color="#EC4899" /><Heart size={18} fill="#EC4899" color="#EC4899" /></span>,
  laugh: "ha ha!",
  gasp: "!!",
  hiss: "hsss",
  paw: <PawPrint size={18} />,
  sleepy: "z z z",
};

export function ReactionBar({ me, players, send }) {
  const mine = players.find((p) => p.id === me);
  const last = useRef(0);
  const [pressed, setPressed] = useState(null);
  const react = (kind) => {
    const now = Date.now();
    if (now - last.current < 900) return;
    last.current = now;
    setPressed(kind);
    setTimeout(() => setPressed(null), 300);
    send("react", { kind });
  };
  return (
    <div className="sticky bottom-3 z-20 flex justify-center pt-2" data-testid="reaction-bar">
      <div className="patch !rounded-full px-1.5 sm:px-2 py-1.5 flex items-center gap-0.5 sm:gap-1 shadow-[0_10px_28px_rgba(44,34,30,0.14)] max-w-full overflow-x-auto">
        {MOODS.map((m) => (
          <button key={m.value} onClick={() => react(m.value)} aria-label={m.label} title={m.label}
            className={`flex flex-col items-center px-1 sm:px-2 py-0.5 rounded-2xl transition-transform duration-150 hover:-translate-y-1 ${pressed === m.value ? "scale-90" : ""}`}
            data-testid={`react-${m.value}`}>
            <CatFace id={me} look={mine?.cat} mood={m.value} size={38} />
            <span className="text-[10px] sm:text-xs font-display text-[var(--yarn-muted)] leading-none whitespace-nowrap">{m.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

function Float({ r }) {
  const [x] = useState(() => 5 + Math.random() * 55);
  return (
    <div className="reaction-float absolute bottom-0 flex flex-col items-center" style={{ left: `${x}%` }} data-testid={`reaction-float-${r.kind}`}>
      <span className="font-display text-sm font-semibold text-[var(--yarn-terracotta)] -mb-1">{EFFECTS[r.kind]}</span>
      <span className="cat-wiggle inline-block"><CatFace id={r.user_id} look={r.cat} mood={r.kind} size={54} /></span>
      <span className="mt-0.5 rounded-full bg-white border border-[var(--yarn-stitch)] px-2 text-[10px] font-display max-w-[90px] truncate">{r.username}</span>
    </div>
  );
}

export function ReactionFloats({ reactions }) {
  return (
    <div className="reaction-zone pointer-events-none fixed bottom-28 w-36 sm:w-44 h-[55vh] z-40" data-testid="reaction-floats">
      {reactions.map((r) => <Float key={r.key} r={r} />)}
    </div>
  );
}
